import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import TeamsIcon from '@atlaskit/icon/core/teams';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.team-view-field.icon-label',
		defaultMessage: 'Team view field icon',
		description: 'Label for the team view field icon',
	},
});

export const TeamViewFieldIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<TeamsIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
};
